import { OrderPage } from "./order";

export const OrdersPage = OrderPage;
